/* Core & libraries */
import React, { Suspense, useEffect, useState } from 'react';
import { useTheme } from 'react-jss';
import { FormattedMessage } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */
import { useLocaleContext } from "../../contexts/localeContext";
import { useAnalytics } from "../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../constants/appConstants";
import { getFullLanguageText } from '../../helpers/general';
import { lazyWithPreload } from '../../helpers/lazyLoadingHelpers';
import { useFormatLocale } from '../../hooks/useFormatLocale';

/* Components */
import LogoSwitcher from "../../components/logoSwitcher";
import SpinnerBasic from '../../components/spinners/SpinnerBasic';
const CountryLanguageModalLazy = lazyWithPreload(() => import('../../components/modals/countryLanguageModal'));
import FlagIconComponent from '../../components/flagIconComponent';

/* Styles */
import styles from './styles.js';
import generalStyles from '../../resources/styles/general';

const DomainVerified = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const general = generalStyles({ theme });

  const locale = useLocaleContext();
  const { locales } = useFormatLocale();

  const [showLanguageModal, setShowLanguageModal] = useState(false);

  const { initAnalytics } = useAnalytics();

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["domainVerified"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  return (
    <div className={`${general.main} ${classes.verifiedDomainPage}`}>
      <div className={`${general.main} ${classes.lang}`}>
        <div
          tabIndex="0"
          onClick={() => setShowLanguageModal(true)}
          className={classes.overlayLink}
          data-testid={'langselector'}
        >
          <FlagIconComponent locale={locale} flagClassName={classes.flagStyle}/>
          <div className={classes.locale}>{getFullLanguageText(locale)}</div>
        </div>
      </div>
      <LogoSwitcher />
      <div className={classes.leaveContainer}>
        <h1 className={classes.title}>
          <FormattedMessage id="verifieddomain.title" />
        </h1>
        <p className={classes.description}>
          <FormattedMessage id="verifieddomain.description1" />
        </p>
        <p className={classes.description}>
          <FormattedMessage id="verifieddomain.description2" />
        </p>
      </div>
      <Suspense fallback={showLanguageModal ? <SpinnerBasic /> : null}>
        {showLanguageModal && (
          <CountryLanguageModalLazy showModal={showLanguageModal} setShowModal={setShowLanguageModal} locales={locales}/>
        )}
      </Suspense>
    </div>
  );
};

export default DomainVerified;
